import React from "react"
import FormField from "../../Components/FormField/FormField"
import CheckableButton from "../../Components/CheckableButton/CheckableButton"
import CancelButton from "../../Components/Buttons/CancelButton"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import Modal from "../../Components/Modal/Modal"

function BankDetailsForm(props) {
  const { state } = props;

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <div className="auth-text-top">
            <FormField
              label="Account Name"
              id="account_name"
              name="account_name"
              required
              placeholder="e.g.: Mary W Haddad"
              onChange={props.onChange}
              value={state.account_name}
            />

            <FormField
              label="BSB"
              id="bsb"
              name="bsb"
              placeholder="BSB (6 digits)"
              required
              onChange={props.onChange}
              pattern="^\d{3}-?\d{3}$"
              value={state.bsb}
            />
          </div>
        </div>

        <div className="col-lg-6">
          <div className="auth-text-top">
            <FormField
              label="Bank Name"
              id="bank_name"
              name="bank_name"
              // required
              placeholder="e.g.: NAB (Optional)"
              onChange={props.onChange}
              value={state.bank_name}
            />

            <FormField
              label="Account Number"
              id="account_number"
              name="account_number"
              placeholder="Numeric, should not exceed 9 digits"
              required
              onChange={(e) => {
                props.onChange(e)
                props.handleDebounceStateChange(e)
              }}
              value={state.account_number}
              disabled={state.account_no_disabled}
              pattern="^\d{3}-?\d{3}-?\d{0,3}$"
            />
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col">
          <CheckableButton
            id="declaration_check"
            checkbox
            noBorder
            required
          >
            I attest that I am the owner and have full authorization of this bank account.
          </CheckableButton>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col">
          <CancelButton
            onClick={props.togglePopup}
            disabled={!state.account_no_disabled}
          >
            Delete Saved Details
          </CancelButton>
        </div>
      </div>

      <Modal
        show={state.show_popup}
        header="Delete Bank Details"
        className="delete-modal"
        onClose={props.togglePopup}
      >
        <h5 className="mb-5">Are you sure? This cannot be undone!</h5>
        <div className="row">
          <div className="col-md-6">
            <CancelButton onClick={props.togglePopup}>Cancel</CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton onClick={props.onDelete}>Delete</ConfirmButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default BankDetailsForm
